module.exports = __webpack_public_path__ + "assets/db2f05ef05523ded8942b56a7d0a7a8a.mp3";